// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__28sHB","emails":"CreateEditClinics_emails__1-qXI","emailTagLabel":"CreateEditClinics_emailTagLabel__1vWKc"};